module.exports = __webpack_public_path__ + "img/logo-white.3125f4bd.svg";